import {
  faCalculator,
  faPhone,
  faCopy,
  faCheck,
  faTimes,
  faShare,
  faKey,
  faClockRotateLeft,
  faFileText,
  faMagnifyingGlass,
  faXmark,
  faGear,
  faRotateRight,
  faSync,
  faArrowRotateRight,
} from "@fortawesome/free-solid-svg-icons";
import { faPaperPlane, faCircleCheck, faClock, faFaceSmile, faFolderOpen, faFile } from "@fortawesome/free-regular-svg-icons";
import { ArrowDown, ArrowLeft, ArrowUp, BarChart } from "react-feather";

export const queryDateFormat = "YYYY-MM-DD";
export const humanDateFormat = "DD/MM/YYYY";
export const humanDateFormatShort = "DD/MM/YY";
export const humanTimeFormat = "HH:mm";
export const totalKpiDef = {
  color: "00B398",
  id: null,
  status: "active",
  text: "Total",
  icon: faCalculator,
};
export const direvadosKpiDef = {
  color: "00b305",
  id: null,
  status: "active",
  text: "Derivados",
  icon: faShare,
};
export const ticketStatusKpiIcons = {
  1: faClock,
  2: faGear,
  3: faKey,
  4: faCopy,
  5: faCircleCheck,
  6: faCheck,
};

export const NotasDePedidoKpiIcons = {
  1: faCheck,
  2: faPhone,
  3: faPaperPlane,
  4: faClockRotateLeft,
  5: faFaceSmile,
  8: faFolderOpen,
  11: faFileText,
};

export const OrdenesDeVentaKpiIcons = {
  1: faCheck,
  2: faRotateRight,
  7: faRotateRight,
  3: faSync,
  4: faClockRotateLeft,
  5: faArrowRotateRight,
  8: faFolderOpen,
  11: faFileText,
};

export const candidatosKpiIcons = {
  1: faMagnifyingGlass,
  2: faPhone,
  3: faPaperPlane,
  4: faFolderOpen,
  5: faCheck,
  6: faXmark,
  7: faFile,
};

export const ticketPriorityIcons = {
  Alta: ArrowUp,
  Media: ArrowLeft,
  Baja: ArrowDown,
  default: BarChart,
};
export const ticketStatusDates = {
  Pendiente: {
    name: "fechaStatusPendienteStart",
    replaceToday: false,
  },
  "En Gestión": {
    name: "fechaStatusEnGestionStart",
    replaceToday: false,
  },
  Resuelto: {
    name: "fechaStatusResueltoStart",
    replaceToday: true,
  },
  Cerrado: {
    name: "fechaStatusCerradoStart",
    replaceToday: false,
  },
  Abierto: {
    name: "fechaCreacionStart",
    replaceToday: false,
  },
};
export const encuestaCategoryKpiIcons = {
  1: faCheck,
  2: faCalculator,
  3: faTimes,
};
export const statusEncuestaEnviada = 1;
export const statusEncuestaRespondida = 2;
export const npsColors = {
  success: "C4D36D",
  warning: "F5D66E",
  error: "D78189",
};
export const puntajes = [
  {
    title: "NPS",
    field: "puntaje1",
  },
  {
    title: "Asesoramiento",
    field: "puntaje2",
  },
  {
    title: "Tiempo",
    field: "puntaje3",
  },
  {
    title: "Acompañamiento",
    field: "puntaje4",
  },
  {
    title: "Experticia",
    field: "puntaje5",
  },
];
